import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";

import generateRelativeHref from "utils/generateRelativeHref";

import { MicrodataContext } from "config/contexts";

import styles from "./TagLink.css";

export default function TagLink({ tag, additionalTags }) {
  // some old RM stories don't have primary tags
  if (tag) {
    const tagUrl = generateRelativeHref(tag.url);
    return (
      <MicrodataContext.Consumer>
        {microdata => {
          const tags = [tag, ...(additionalTags || [])].map(tag => tag.name);

          return (
            <>
              {microdata && (
                <meta itemProp="keywords" content={tags.join(",")} />
              )}
              <Link
                to={tagUrl}
                className={classNames(styles.root, "gtm-primary-tag-link")}
              >
                {tag.name}
              </Link>
            </>
          );
        }}
      </MicrodataContext.Consumer>
    );
  }
  return null;
}

TagLink.propTypes = {
  tag: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  additionalTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
};
